import { Directive, ElementRef, HostListener, Output, EventEmitter, ViewChild} from '@angular/core';
import { popupService } from "../services/popup.service";

@Directive({
  selector: '[svcSpeedBump]'
})

export class SpeedBumpDirective {

  constructor(private el:ElementRef, private popupService:popupService) { 

  }

  @HostListener('click', ['$event']) onClick(e){
    e.preventDefault();
    let obj={};
    let hostRegex = /^(?:https?:\/\/)?(?:www\.)?/i;
    let nonCappedDomainName = this.el.nativeElement.host.toLowerCase().replace(hostRegex, '');
    let InitiCapedDomainName= nonCappedDomainName.charAt(0).toUpperCase()+nonCappedDomainName.slice(1);
    obj["fullHref"]=this.el.nativeElement.href;
    obj["host"]=InitiCapedDomainName;
    obj["target"]=this.el.nativeElement.target;
    this.popupService.openSpeedbump.emit(obj);
  }

  ngOnInit(){

  }
  
}
